<template>
  <v-col cols="12" md="8">
    <v-card color="white">
      <v-container fluid>
        <v-row align="center">
          <v-col cols="12" md="8">
            <h2 class="pl-4">Artigos</h2>
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="orderBy"
              label="Ordenar"
              no-data-text="Nenhum registro encontrado"
              :items="order"
              @change="saveLocalOrderBy"
            ></v-select>
          </v-col>
        </v-row>
        <v-list v-if="computedArticles.length && !loading">
          <v-list-item v-for="article of computedArticles" :key="article._id">
            <v-list-item-content>
              <v-list-item-title class="list-title">
                <v-icon small left>far fa-file-alt</v-icon>
                <router-link :to="{ name: 'Documento', params: { id: article._id } }"><span v-if="article.classificacao">{{ article.classificacao }} - </span>{{ article.titulo }}</router-link>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <PageLoading v-else-if="loading" />
        <v-subheader v-else class="body-1">Nenhum documento encontrado.</v-subheader>
      </v-container>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { serialize } from '../../helpers';

export default {
  name: 'ArticlesView',
  data: () => ({
    orderBy: 'Data',
    order: ['Título', 'Data', 'Classificacao']
  }),
  computed: {
    ...mapGetters(['articles', 'loading']),
    query() {
      return serialize(this.$route.query);
    },
    computedArticles() {
      if (this.orderBy === 'Título') return this.articlesByAZ;
      if (this.orderBy === 'Data') return this.articlesByDate;
      if (this.orderBy === 'Classificacao') return this.articlesByClassificacao;
      // if (this.orderBy === 'Popularidade') return this.articlesByPopular;
      return this.articles;
    },
    articlesByDate() {
      const sortedArticles = this.articles.sort((a, b) => {
        const aDate = new Date(a.updatedAt).getTime();
        const bDate = new Date(b.updatedAt).getTime();
        if (aDate > bDate) return -1;
        if (aDate < bDate) return 1;
        return 0;
      });
      return sortedArticles
    },
    articlesByAZ() {
      return this.articles.sort((a, b) => a.titulo < b.titulo ? -1 : 1);
    },
    articlesByClassificacao() {
      return this.articles.sort((a, b) => a.classificacao < b.classificacao ? -1 : 1);
    },
    // articlesByPopular() {
    //   return this.articles.sort((a, b) => a.Views - b.Views);
    //   return [];
    // }
  },
  methods: {
    ...mapActions(['fetchArticles']),
    loadLocalOrderBy() {
      if (localStorage.getItem('orderBy')) {
        this.orderBy = localStorage.getItem('orderBy');
      }
    },
    saveLocalOrderBy() {
      localStorage.setItem('orderBy', this.orderBy);
    },
    getArticles() {
      this.fetchArticles({ limit: 999, query: this.query });
    }
  },
  watch: {
    query() {
      this.getArticles();
    }
  },
  created() {
    this.getArticles();
    this.loadLocalOrderBy();
  }
}
</script>

<style scoped>
.list-title {
  font-size: 1.125rem;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
</style>